module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/linkedin-white-a459eb75e9bc0b32d522e23d3a7bd7f8.svg";